// extracted by mini-css-extract-plugin
module.exports = {"is-invalid":"VSelect_is-invalid_tO8uN","select":"VSelect_select_2RNdv","error":"VSelect_error_BM51p"};